import React, { useEffect } from 'react';
import { BsTwitter } from 'react-icons/bs';
import { TwitterShareButton } from 'react-share';
import About from '../components/Marketing/About';
import Rules from '../components/Marketing/Rules';
import HeaderMarketing from '../components/Header/HeaderMarketing';
import Footer from '../components/Footer/Footer';
import BottomMainMarketing from '../components/Marketing/BottomMainMarketing';
import FAQMarketing from '../components/Marketing/FAQMarketing';
import MarginBottom from '../components/MarginBottom';
import { FaCheckCircle } from 'react-icons/fa';
import MarketingModal from '../components/Marketing/MarketingModal';
import axios from '../utils/axios';
import { notifyError } from '../utils/toastError';
import { getMarketingFaqs } from '../Services/MarketingFaq';

const styles = {
  links: 'cursor-pointer transition ease-out delay-50  hover:-translate-y-1 hover:scale-110  duration-200',
  test: 'h-[100vh] overflow-hidden',
};

const Marketing = () => {
  const [showModal, setShowModal] = React.useState(false);
  const [shareData, setShareData] = React.useState({
    hashtag: '',
    link: '',
  });
  const [marketingFaqs, setMarketingFaqs] = React.useState([]);


  const fetchData = async () => {
    try {
      const response = await axios.get(`api/marketinghl/getmarketinghl`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        }
      );
      const fData = await response.data.marketing;

      setShareData({
        hashtag: response.data.marketing[1].hashtag,
        link: response.data.marketing[1].link,



      });

    } catch (error) {
      console.log(error.message);
      notifyError('Error fetching data===');
    }
  };

  useEffect(() => {
    fetchData();
    fetchMarketingFaq();
  }, []);

  const fetchMarketingFaq = async () => {
    const resp = await getMarketingFaqs();
    if (resp.data.success) {
      setMarketingFaqs(resp.data.data);
    } else {
      console.log("Error to fetch marketing faqs");
    }
  }

  // console.log(shareData)

  return (
    <div className={showModal ? styles.test : ''}>
      <MarketingModal setShowModal={setShowModal} showModal={showModal} />
      <div className="w-[100vw] h-[100vh] flex flex-col justify-between z-10">
        <HeaderMarketing />
        <BottomMainMarketing />
        <div className="flex items-center justify-center w-screen h-screen">
          <div className="flex justify-center items-center px-10 py-20 sm:px-32 bg-black/50 rounded-md shadow-xl">
            <div className="flex flex-col items-center w-full">
              <h1 className="font-bold text-lyellow text-3xl w-full text-center sm:text-4xl md:text-5xl">
                Share and Earn
              </h1>

              <h6 className="mb-4 text-xl text-center sm:text-2xl w-full text-white md:text-3xl mt-3">
                Share on social media and earn reward
              </h6>

              <div className="w-full flex justify-evenly items-center text-5xl text-lyellow mt-5">
                <TwitterShareButton
                  url={
                    shareData.link
                      ? shareData.link
                      : ''
                  }
                  hashtags={[
                    shareData.hashtag ? shareData.hashtag : '',
                  ]}
                >
                  <BsTwitter className={styles.links} />
                </TwitterShareButton>

                <FaCheckCircle
                  className={styles.links}
                  onClick={() => setShowModal(true)}
                />
              </div>
            </div>
          </div>
        </div>

        
      </div>

      <div className="flex justify-center items-center mb-5">
        <div className="w-11/12 h-[0.2px] border-t border-lyellow" />
      </div>

      <div className="px-[5em] mt-10">
        <About />
        <div className="mt-10" />
        <Rules />
      </div>
      <div className="my-10" />
      <MarginBottom />

      <div className="mb-10" />

      {marketingFaqs.length > 0 ?
        <div>
          <FAQMarketing faqs={marketingFaqs} />
        </div>
        : null}

      <Footer />

    </div>
  );
};

export default Marketing;
